import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Settings, LogOut, Info } from 'lucide-react'
import { useAuthStore } from '../../store/authStore'
import { useLogout } from '../../api/auth'

export default function Topbar() {
  const user = useAuthStore((s) => s.user)
  const { mutate: logout } = useLogout()
  const navigate = useNavigate()
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <header className="h-16 flex items-center justify-between border-b border-border/50 bg-background/95 backdrop-blur-sm px-4 z-20 relative">
      {/* Logo */}
      <div className="flex items-center gap-3">
        <span className="font-mono font-bold text-lg tracking-tight text-primary">
          Cheesy
        </span>
        <span className="text-xs text-muted-foreground/60 font-mono hidden sm:block">
          Sandwich Emergency Platforms (Demo)
        </span>
      </div>

      {/* User menu */}
      <div className="relative">
        <button
          onClick={() => setMenuOpen((p) => !p)}
          className="flex items-center gap-2 rounded-lg px-3 py-1.5 hover:bg-accent/50 transition-colors"
        >
          <div className="h-7 w-7 rounded-full bg-primary/20 flex items-center justify-center text-xs font-mono font-bold text-primary">
            {user?.username?.[0]?.toUpperCase() ?? '?'}
          </div>
          <span className="text-sm hidden sm:block">{user?.displayName ?? user?.username}</span>
        </button>

        {menuOpen && (
          <>
            <div className="fixed inset-0 z-10" onClick={() => setMenuOpen(false)} />
            <div className="absolute right-0 top-full mt-1 z-20 w-48 rounded-lg border border-border bg-popover shadow-xl overflow-hidden">
              <div className="px-3 py-2 border-b border-border">
                <div className="text-xs font-medium">{user?.username}</div>
                <div className="text-xs text-muted-foreground capitalize">{user?.role}</div>
              </div>
              <button
                onClick={() => { navigate('/settings'); setMenuOpen(false) }}
                className="flex w-full items-center gap-2 px-3 py-2 text-sm hover:bg-accent/50 transition-colors"
              >
                <Settings size={14} />
                Settings
              </button>
              <button
                onClick={() => { navigate('/about'); setMenuOpen(false) }}
                className="flex w-full items-center gap-2 px-3 py-2 text-sm hover:bg-accent/50 transition-colors"
              >
                <Info size={14} />
                About
              </button>
              <button
                onClick={() => { logout(); setMenuOpen(false) }}
                className="flex w-full items-center gap-2 px-3 py-2 text-sm text-destructive hover:bg-destructive/10 transition-colors"
              >
                <LogOut size={14} />
                Sign out
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  )
}
